import SvgIcon from '@mui/material/SvgIcon';

export default function CalendarIcon() {
  return (
    <SvgIcon
      sx={{
        fontSize: '2.5rem',
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" rx="24" fill="#F4F4F4" />
        <rect
          x="12"
          y="16"
          width="24"
          height="20"
          rx="2"
          stroke="#212121"
          stroke-width="2"
        />
        <path
          d="M13.3335 22.668H34.6668"
          stroke="#212121"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M20 29.332H28"
          stroke="#212121"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M18.6665 12L18.6665 17.3333"
          stroke="#212121"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M29.3335 12L29.3335 17.3333"
          stroke="#212121"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </SvgIcon>
  );
}
